import { makeAutoObservable } from 'mobx';

import { DroneCommand } from '../types/DroneCommands/CommandTypes';

class CommandStore {
  socket: WebSocket | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSocket = (socket: WebSocket | null): void => {
    this.socket = socket;
  };

  sendCommand = (command: DroneCommand): void => {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(command));
    }
  };

  clearCommandStore() {
    this.socket = null;
  }
}

export const commandStore = new CommandStore();
